import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5","key":"svg-0"}],["path",{"d":"M10 12l-2 -2.2l.6 -1","key":"svg-1"}]]

/**
 * IconDiamond
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZGlhbW9uZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNiA1aDEybDMgNWwtOC41IDkuNWEuNyAuNyAwIDAgMSAtMSAwbC04LjUgLTkuNWwzIC01IiAvPgogIDxwYXRoIGQ9Ik0xMCAxMmwtMiAtMi4ybC42IC0xIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/diamond
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDiamond = createReactComponent('outline', 'diamond', 'Diamond', __iconNode);

export default IconDiamond;